import { useMemo } from 'react';
import { SelectOption } from '@web-for-marketing/react-ui';
import { getSubindustryDropdownType } from '@helpers/formHelpers/industryDropdownHelper';
import { getTranslation } from '@helpers/languageTranslations';
import { useTranslation } from '@stateManagement/TranslationContext';
import { useLazyLoadedSelectOptions, LazyLoadedSelectOptionsTypes } from '@hooks/useLazyLoadedSelectOptions';

export function useSubindustryDropdown(industry: string): [string, string, SelectOption[]] {
    const { selectedLanguageTranslation } = useTranslation();
    const formTranslations = useMemo(() => {
        return getTranslation(selectedLanguageTranslation, 'formTranslations');
    }, [selectedLanguageTranslation]);
    const placeholderTranslations = useMemo(() => {
        return getTranslation(selectedLanguageTranslation, 'formPlaceholders');
    }, [selectedLanguageTranslation]);
    const label = formTranslations?.subIndustry || 'Sub-Industry';
    const placeholder = placeholderTranslations?.subIndustryPlaceholder || 'Select a subindustry category\u2026';
    const subindustryDropdown = useMemo(() => (industry ? [getSubindustryDropdownType(industry)] : []), [industry]);
    const [subindustryOptions] = useLazyLoadedSelectOptions(subindustryDropdown as LazyLoadedSelectOptionsTypes[]);

    return [label, placeholder, subindustryOptions || []];
}
